import styles from './_songTabs.module.scss'
import { t } from '../../../../utils/i18n'
import { ChordItem } from '../../../../utils/songs/songTabsCommon'
import { ReactSVG } from 'react-svg'
import { downloadFile } from '../../../../utils/downloadFile'
import { Song } from '../../../../__generated__/graphql'

const Print = () => (
  <div>
    <ReactSVG src="../../images/print.svg" />
  </div>
)

const Download = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29">
      <defs>
        <clipPath id="ymv0a">
          <path
            fill="#fff"
            d="M14.5 0C22.508 0 29 6.492 29 14.5S22.508 29 14.5 29 0 22.508 0 14.5 6.492 0 14.5 0z"
          />
        </clipPath>
      </defs>
      <g>
        <g>
          <g>
            <path
              fill="none"
              strokeMiterlimit="20"
              strokeWidth="4"
              d="M14.5 0C22.508 0 29 6.492 29 14.5S22.508 29 14.5 29 0 22.508 0 14.5 6.492 0 14.5 0z"
              clipPath='url("#ymv0a")'
            />
          </g>
          <g>
            <g>
              <path d="M8.382 21.006a1 1 0 0 1-1-1v-.285a1 1 0 0 1 1-1h12.623a1 1 0 0 1 1 1v.285a1 1 0 0 1-1 1z" />
            </g>
            <g>
              <path d="M15.191 16.742a.914.914 0 0 1-1.32 0l-5.776-6.028c-.557-.58-.145-1.546.66-1.546h11.554c.805 0 1.217.965.66 1.546l-3.226 3.366z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

const SongActions: React.FC<{
  song: Song
  songKey: string
  capo?: string
  chordCharts: ChordItem[]
  lyrics?: boolean
}> = ({ song, songKey, capo, chordCharts, lyrics = false }) => (
  <div className={styles.printActions}>
    <button
      type="button"
      className={styles.print}
      onClick={() => {
        printSongVerses({
          song,
          songKey,
          capo,
          verses: chordCharts,
          lyrics,
          newTab: true
        })
      }}
    >
      <span className={`${styles.tooltip} ${styles.print}`}>{t('print')}</span>
      <Print />
    </button>
    <button
      type="button"
      className={styles.download}
      onClick={() => {
        printSongVerses({ song, songKey, capo, lyrics, verses: chordCharts })
      }}
    >
      <span className={`${styles.tooltip} ${styles.download}`}>
        {t('download')}
      </span>
      <Download />
    </button>
  </div>
)

// if verses null server will generate items from scratch
// pass newTab = true to open the PDF in new tab
export const printSongVerses = async ({
  song,
  songKey,
  capo,
  verses,
  lyrics = false,
  newTab = false
}: {
  song: Song
  songKey: string
  capo?: string
  verses: ChordItem[]
  lyrics?: boolean
  newTab?: boolean
}) => {
  const tab = newTab ? window.open('about:blank', '_blank') : null
  await fetch(`${process.env.NEXT_PUBLIC_OLD_URL}/song_verses/${song.id}`, {
    method: 'POST',
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ song_key: songKey, capo, verses, lyrics })
  })
    .then((response) => response.blob())
    .then((blob) => downloadFile(blob, `${song.title}.pdf`, tab))
}

export default SongActions
